import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { ExpandCollapse, Typography } from '@telus-uds/components-web';

import {
  getFormStepFieldsIoT,
  contentfulFormConfig
} from '../../../../../contentful';
import FormSummaryGroup from '../../../../../form/formSummaryGroup';
import Note from '../../../../../note';
import {
  fieldIotProductSelected,
  fieldIotActivationOrRenwal
} from '../../../../../utils/constant';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import { getLocale } from '../../../../../misc';

const OrderSummary = ({ orderData }) => {
  const {
    contentfulValues: {
      valueGeotab,
      valueFleetcomplete,
      valuePowerFleet,
      valueRaven,
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch,
      valueGeoforce,
      valueActivation,
      valueRenewal
    },
    ORDERS: { ORDER_SUMMARY }
  } = useLocalizedStringsContext();

  const [orderSummary, setOrderSummary] = useState(null);
  const locale = getLocale();
  const config = { ...contentfulFormConfig, locale };
  const valueViewType = _.get(orderData, 'viewType', '');
  const valueProductSelected = _.get(orderData, fieldIotProductSelected, '');
  const valueActivationOrRenwal = _.get(
    orderData,
    fieldIotActivationOrRenwal,
    ''
  );

  useEffect(() => {
    let summaryFormStepIndex = 0;
    if (
      valueProductSelected === valueGeotab &&
      valueActivationOrRenwal === valueActivation
    )
      summaryFormStepIndex = 0;
    else if (
      valueProductSelected === valueGeotab &&
      valueActivationOrRenwal === valueRenewal
    )
      summaryFormStepIndex = 1;
    else if (
      valueProductSelected === valueFleetcomplete &&
      valueActivationOrRenwal === valueActivation
    )
      summaryFormStepIndex = 2;
    else if (
      valueProductSelected === valueFleetcomplete &&
      valueActivationOrRenwal === valueRenewal
    )
      summaryFormStepIndex = 3;
    else if (valueProductSelected === valueRaven) summaryFormStepIndex = 4;
    else if (valueProductSelected === valueNorthStarSystems)
      summaryFormStepIndex = 5;
    else if (valueProductSelected === valueNorthStarSystemsFarmAndRanch)
      summaryFormStepIndex = 6;
    else if(valueProductSelected === valuePowerFleet)
      summaryFormStepIndex = 8;
    else if (
      valueProductSelected === valueGeoforce &&
      valueActivationOrRenwal === valueActivation
    )
      summaryFormStepIndex = 9;
    else if (
      valueProductSelected === valueGeoforce &&
      valueActivationOrRenwal === valueRenewal
    )
      summaryFormStepIndex = 10;

    getFormStepFieldsIoT(config, summaryFormStepIndex, setOrderSummary);
  }, []);

  return (
    <div className="view-order-summary">
      <Typography heading="h3" variant={{ size: 'h3' }} block>{ORDER_SUMMARY}</Typography>
      <ExpandCollapse initialOpen={[]} topDivider={false}>
        {(expandProps) => (
          <>
            {orderSummary &&
              orderSummary.map(({ fields }) => {
                const { note, formSummaryGroup, title } = fields;
                if (
                  valueProductSelected === valueNorthStarSystems &&
                  valueViewType === 'advancedView' &&
                  title === 'Summary'
                )
                  return null;
                return (
                  <ExpandCollapse.Panel
                    key={title}
                    {...expandProps}
                    panelId={title}
                    control={<Typography variant={{ bold: true }}>{title}</Typography>}
                  >
                    <>
                      {note && note.content && <Note data={note} type="richText" />}
                      <FormSummaryGroup
                        data={formSummaryGroup}
                        orderData={orderData}
                      />
                    </>
                  </ExpandCollapse.Panel>
                );
              })}
          </>
        )}
      </ExpandCollapse>
    </div>
  );
};

OrderSummary.propTypes = {
  orderData: PropTypes.shape({}).isRequired
};

export default OrderSummary;
